import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { DatePicker } from "../../../shared/components/date-picker/date-picker";
import { dateFormatValidator, monthValidator } from '../../../shared/utils/functions';
import { Button } from "../../../shared/ui/button/button";
import { Modal } from '../../../core/services/modal';
import { StatementModal } from '../../../shared/components/modals/statement-modal/statement-modal';
import { Popup } from '../../../core/services/popup';

@Component({
  selector: 'app-download-statement',
  imports: [TranslatePipe, CommonModule, DatePicker, ReactiveFormsModule, Button],
  templateUrl: './download-statement.html',
  styleUrl: './download-statement.css'
})
export class DownloadStatement {
  currentTab: 'month' | 'date' = 'month';

  monthForm = new FormGroup({
    startMonth: new FormControl(null, [
      Validators.required,
      monthValidator
    ]),
    endMonth: new FormControl(null, [
      Validators.required,
      monthValidator
    ]),
  });

  dateForm = new FormGroup({
    startDate: new FormControl(null, [
      Validators.required,
      dateFormatValidator
    ]),
    endDate: new FormControl(null, [
      Validators.required,
      dateFormatValidator
    ]),
  });

  constructor(private modalService: Modal, private popup: Popup) {
  }

  setTab(tab: 'month' | 'date') {
    this.currentTab = tab;
    if (tab === 'month') {
      this.dateForm.reset();
    } else {
      this.monthForm.reset();
    }
  }

  handleFormSubmission() {
    if (this.currentTab === 'month') {
      if (this.monthForm.invalid) return;

      const payload = this.monthForm.value;
      // console.log("Month form submitted:", payload);

      // Call API here
      // this.statementService.generateByMonth(payload).subscribe(...)
    }
    else {
      if (this.dateForm.invalid) return;

      const payload = this.dateForm.value;
      // console.log("Date form submitted:", payload);

      // Call API here
      // this.statementService.generateByDate(payload).subscribe(...)
    }
    this.getStatementModal();
  }

  getStatementModal() {
    const statementModal: any = {
      backdropClosable: false,
      showCancelButton: false,
      accountsData: {},
      onConfirm: () => {

        this.popup.show({
          message: 'Statement generated',
          type: 'success',
          duration: 3000,
          position: 'bottom',
          icon: 'assets/icons/check-popup.svg',
        });
      }
    };

    this.modalService.open(StatementModal, statementModal);
  }

  getControl(control: string, form: 'monthForm' | 'dateForm'): FormControl {
    const f = this[form] as FormGroup;
    return f.get(control) as FormControl;
  }

}
